import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { getFacilityContext } from "@/utils/route-context";
import { registerAiChartContext, unregisterAiChartContext } from "./pageContext";

import AiChartAction from "./AiChartAction";

const AiChartContextRegistration = ({ context, showAction = true }) => {
  const { companyId, facilityId } = useSelector((state) => getFacilityContext(state));
  const serialized = JSON.stringify(context || null);
  const chartId = context?.chart?.chartId || context?.chart?.chart_id;

  useEffect(() => {
    if (!context) return;
    registerAiChartContext({
      companyId,
      facilityId,
      pageId: context.pageId,
      chart: context.chart,
      status: context.status,
      capturedAt: context.capturedAt,
      refresh: context.refresh,
    });
  }, [companyId, facilityId, context?.pageId, serialized, context?.refresh]);

  // Updating a chart's load state must not temporarily remove it from the
  // page: another chart may be ready while this one is still refreshing.
  useEffect(() => {
    if (!context || !chartId) return;
    return () =>
      unregisterAiChartContext({
        companyId,
        facilityId,
        pageId: context.pageId,
        chartId,
      });
  }, [companyId, facilityId, context?.pageId, chartId]);

  return showAction && chartId ? <AiChartAction chartId={chartId} /> : null;
};

export default AiChartContextRegistration;
